import { Eye, EyeOff } from "lucide-react";

interface Props {
	isPasswordVisible: boolean;
	toggle: () => void;
}

const PasswordVisibilityToggler = (props: Props): JSX.Element => {
	const { isPasswordVisible, toggle } = props;

	return (
		<button
			onClick={toggle}
			type="button"
			className="w-full h-full border-none flex justify-center items-center bg-transparent outline-none cursor-pointer"
		>
			{isPasswordVisible ? (
				<Eye className="h-3.5 w-3.5 text-white" />
			) : (
				<EyeOff className="h-3.5 w-3.5 text-white" />
			)}
		</button>
	);
};

export default PasswordVisibilityToggler;
